// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ErrorsController from "./errors_controller"
application.register("errors", ErrorsController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SmsCounterController from "./sms_counter_controller"
application.register("sms-counter", SmsCounterController)
